import * as yup from 'yup';
import { buildValidationObject } from '../../util/form';

// Remarks
// Composite Rebuilding/Veneers = Composite Rebuilding/Veneers (F.I.T.)
// Porcelain Veneers = Ceramic Veneers
// Builds the Smile Design question configuration.

export const smilDesignQuestionsConfigFirstFit = (formValues = undefined, isMarieGroup = false, isUpSellTab = false, isTWGroup = false, isSEAGroup = false) => {
    let object = {
        1: {
            component: 'RadioRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.plannedRestorationSolution',
            name: 'plannedRestorationSolution',
            remark: '@PatientInfo.smileDesign.prescriptionNotes.question.plannedRestorationSolutionRemark',
            option: [
                {
                    value: isMarieGroup ? 'option.formaInjectionTechnique' : 'option.flowableInjectionTechnique',
                    label: isMarieGroup
                        ? `@PatientInfo.smileDesign.prescriptionNotes.option.formaInjectionTechniqueFirstFit`
                        : `@PatientInfo.smileDesign.prescriptionNotes.option.flowableInjectionTechniqueFirstFit`,
                    desc: isMarieGroup
                        ? `@PatientInfo.smileDesign.prescriptionNotes.option.formaInjectionTechniqueDesc`
                        : `@PatientInfo.smileDesign.prescriptionNotes.option.flowableInjectionTechniqueDesc`,
                    width:'250',
                    paddingBottom:48,
                    disable: isTWGroup,
                },
                {
                    value: 'option.ceramicVeneersCrowns',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.ceramicVeneersCrownsFirstFit',
                    desc: '@PatientInfo.smileDesign.prescriptionNotes.option.ceramicVeneersCrownsDesc',
                    width:'230',
                    paddingBottom:48
                },
                {
                    value: 'option.guidedVeneerTreatment',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.guidedVeneerTreatment',
                    desc: '@PatientInfo.smileDesign.prescriptionNotes.option.guidedVeneerTreatmentDesc',
                    paddingBottom: 48,
                    disable: !isMarieGroup,
                },
            ],
            // validation: yup.string().required('Required'),
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),

            children: {
                '2A': {
                    component: 'SDTeethRhf',
                    question: '@PatientInfo.smileDesign.prescriptionNotes.question.chooseDentalMorphology',
                    name: 'teethSD',
                    showSingleError: false,
                    // validation: yup
                    //     .array()
                    //     .when(['plannedRestorationSolution'], (v, _) => { // <= Q2A
                    //         if (v[0] === 'option.ceramicVeneers') {
                    //             return yup.array()
                    //                 .required('Choose one at least')
                    //                 .typeError('Choose one at least')
                    //                 .min(1, 'Choose one at least')
                    //         }
                    //     }),

                    // disable: !(formValues?.plannedRestorationSolution === 'option.ceramicVeneers'),
                    reset: '',
                },
            },
            showInUpsell: true,
        },
        2: {
            component: 'MyTeethChoice',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.selectTeethSimulationFirstFit',
            name: 'teethForSimulation', // Picture
            alwaysShowRequired: true,
            validation: yup
                .array()
                .required('@NewPatient.prescriptionNotes.requiredInformation')
                .typeError('@NewPatient.prescriptionNotes.requiredInformation')
                .min(1, '@NewPatient.prescriptionNotes.requiredInformation'),
            checkSuccess: true,
            quickTeethOption: [
                {
                    value: 'select',
                    label: 'Select',
                    teeth: [],
                },
                {
                    isGroup: true,
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.upperArch',
                },
                {
                    value: 'upper-2-2',
                    label: '2-2',
                    teeth: [6, 7, 8, 9],
                },
                {
                    value: 'upper-3-3',
                    label: '3-3',
                    teeth: [5, 6, 7, 8, 9, 10],
                },
                {
                    value: 'upper-4-4',
                    label: '4-4',
                    teeth: [4, 5, 6, 7, 8, 9, 10, 11],
                },
                {
                    value: 'upper-5-5',
                    label: '5-5',
                    teeth: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                },
                {
                    value: 'upper-all',
                    label: 'All',
                    teeth: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                },
                {
                    isGroup: true,
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.lowerArch',
                },
                {
                    value: 'lower-2-2',
                    label: '2-2',
                    teeth: [22, 23, 24, 25],
                },
                {
                    value: 'lower-3-3',
                    label: '3-3',
                    teeth: [21, 22, 23, 24, 25, 26],
                },
                {
                    value: 'lower-4-4',
                    label: '4-4',
                    teeth: [20, 21, 22, 23, 24, 25, 26, 27],
                },
                {
                    value: 'lower-5-5',
                    label: '5-5',
                    teeth: [19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
                },
                {
                    value: 'lower-all',
                    label: 'All',
                    teeth: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
                },
                {
                    isGroup: true,
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.dualArch',
                },
                {
                    value: 'both-2-2',
                    label: '2-2',
                    teeth: [6, 7, 8, 9, 22, 23, 24, 25],
                },
                {
                    value: 'both-3-3',
                    label: '3-3',
                    teeth: [5, 6, 7, 8, 9, 10, 21, 22, 23, 24, 25, 26],
                },
                {
                    value: 'both-4-4',
                    label: '4-4',
                    teeth: [4, 5, 6, 7, 8, 9, 10, 11, 20, 21, 22, 23, 24, 25, 26, 27],
                },
                {
                    value: 'both-5-5',
                    label: '5-5',
                    teeth: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
                },
                {
                    value: 'both-all',
                    label: 'All',
                    teeth: [
                        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
                        22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
                    ],
                },
                {
                    value: 'custom',
                    label: 'Custom',
                    teeth: [],
                },
            ],
            showInUpsell: true,
        },
        3: {
            component: 'RadioRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.increaseVerticalDimensionFirstFit',
            name: 'verticalDimension',
            remark: '@PatientInfo.smileDesign.prescriptionNotes.question.verticalDimensionPosteriorRemark',
            option: [
                {
                    value: 'option.notIncreaseVerticalDimension',
                    label: `@PatientInfo.smileDesign.prescriptionNotes.option.notIncreaseVerticalDimension`,
                },
                {
                    value: 'option.increaseVerticalDimension',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.increaseVerticalDimension',
                },
            ],
            children: [
                {
                    component: 'QuestionTwoGroupOptionRhf',
                    question: '',
                    name: 'verticalDimensionPosterior',
                    direction: 'row',
                    showError: true,
                    showWhen: { field: 'verticalDimension', value: 'option.increaseVerticalDimension' },
                    children: {
                        a: {
                            component: 'SelectRhf',
                            question: '',
                            name: 'verticalDimensionUpperPosterior',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.upperPosteriorFirstFit',
                            defaultValue: isUpSellTab ? '' : '0',
                            option: [
                                ...(isUpSellTab
                                    ? [{ value: '', label: 'None' }]
                                    : [{ value: '0', label: 'No increase' }]),
                                {
                                    value: '1mm',
                                    label: `1mm`,
                                },
                                {
                                    value: '2mm',
                                    label: '2mm',
                                },
                                {
                                    value: '3mm',
                                    label: '3mm',
                                },
                                {
                                    value: '4mm',
                                    label: '4mm',
                                },
                                {
                                    value: '5mm',
                                    label: '5mm',
                                }
                            ],
                        },
                        b: {
                            component: 'SelectRhf',
                            question: '',
                            name: 'verticalDimensionLowerPosterior',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.lowerPosteriorFirstFit',
                            defaultValue: isUpSellTab ? '' : '0',
                            option: [
                                ...(isUpSellTab
                                    ? [{ value: '', label: 'None' }]
                                    : [{ value: '0', label: 'No increase' }]),
                                {
                                    value: '1mm',
                                    label: `1mm`,
                                },
                                {
                                    value: '2mm',
                                    label: '2mm',
                                },
                                {
                                    value: '3mm',
                                    label: '3mm',
                                },
                                {
                                    value: '4mm',
                                    label: '4mm',
                                },
                                {
                                    value: '5mm',
                                    label: '5mm',
                                }
                            ],
                        },
                    },
                },
            ],
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
            showInUpsell: true,
        },
        4: {
            component: 'RadioRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.desiredMaxillaryMidlinePosition',
            name: 'maxillaryMidlinePosition',
            direction: 'column',
            option: [
                {
                    value: 'option.maintainExistingMidlinePosition',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.maintainExistingMidlinePosition',
                },
                {
                    value: 'option.alignWithFacialReferenceLine',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.alignWithFacialReferenceLine',
                },
                {
                    value: 'option.customClinicianDefinedTarget',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.customClinicianDefinedTarget',
                },
            ],
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
            showInUpsell: true,
        },
        5: {
            component: 'RadioRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.desiredMandibularMidlineRelationship',
            name: 'mandibularMidlineRelationship',
            direction: 'column',
            disable:
                !Array.isArray(formValues?.teethForSimulation) ||
                !formValues.teethForSimulation.some((toothNo) => Number(toothNo) >= 16),
            option: [
                {
                    value: 'option.maintainExistingMidlinePosition',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.maintainExistingMidlinePosition',
                },
                {
                    value: 'option.coordinateWithPlannedMaxillaryMidline',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.coordinateWithPlannedMaxillaryMidline',
                },
                {
                    value: 'option.customClinicianDefinedTarget',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.customClinicianDefinedTarget',
                },
            ],
            showInUpsell: true,
        },
        6: {
            component: 'RadioRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.maxillaryMidlineAngulation',
            name: 'maxillaryMidlineAngulation',
            direction: 'column',
            option: [
                {
                    value: 'option.maintainExistingAngulation',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.maintainExistingAngulation',
                },
                {
                    value: 'option.correctCantToFacialVerticalReference',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.correctCantToFacialVerticalReference',
                },
                {
                    value: 'option.customClinicianDefinedTarget',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.customClinicianDefinedTarget',
                },
            ],
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
            showInUpsell: true,
        },
        7: {
            component: 'RadioRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.cantingInSimulation',
            name: 'cantingInSimulation',
            direction: 'column',
            option: [
                {
                    value: 'option.maintainExistingCant',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.maintainExistingCant',
                },
                {
                    value: 'option.correctCantingParallelToInterpupillaryLine',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.correctCantingParallelToInterpupillaryLine',
                },
                {
                    value: 'option.correctCantingParallelToFloor',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.correctCantingParallelToFloor',
                },
            ],
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
            showInUpsell: true,
        },
        8: {
            component: 'RadioRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.softTissueModification',
            name: 'softTissueModification',
            remark: '@PatientInfo.smileDesign.prescriptionNotes.question.softTissueModificationNote',
            remarkWhen: 'option.yes',
            option: [
                {
                    value: 'option.yes',
                    label: isSEAGroup
                        ? '@PatientInfo.smileDesign.prescriptionNotes.option.yesFirstFitSEA'
                        : '@PatientInfo.smileDesign.prescriptionNotes.option.yesFirstFit',
                },
                {
                    value: 'option.no',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.no',
                },
            ],
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
            showInUpsell: true,
        },
        9: {
            component: 'QuestionTwoGroupOptionRhf',
            question: ' ', // Explain: only show the order
            children: {
                a: {
                    component: 'RadioRhf',
                    name: 'buccalFacial_teethReduction',
                    question:
                        '@PatientInfo.smileDesign.prescriptionNotes.question.teethReductionPreference_buccalFacial',
                    // notShowOrder: true,
                    option: [
                        {
                            value: 'option.noReduction',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.noReduction',
                        },
                        {
                            value: '0-0.5mm',
                            label: '0-0.5mm',
                        },
                        {
                            value: '0.5-1mm',
                            label: '0.5-1mm',
                        },
                        {
                            value: 'option.noPreference',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.noPreference',
                        },
                    ],
                    // disable: !(Array.isArray(formValues?.teethReductionPreference)
                    //     && (formValues?.teethReductionPreference).includes('option.buccalFacial')),
                    validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
                    // .when(['palatalLingual_teethReduction'], (v, _) => {
                    //     if (!v[0]) {
                    //         return yup.string().required('Required')
                    //     }
                    // }),
                },
                b: {
                    component: 'RadioRhf',
                    name: 'palatalLingual_teethReduction',
                    question:
                        '@PatientInfo.smileDesign.prescriptionNotes.question.teethReductionPreference_palatalLingual',
                    // notShowOrder: true,
                    option: [
                        {
                            value: 'option.noReduction',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.noReduction',
                        },
                        {
                            value: '0-0.5mm',
                            label: '0-0.5mm',
                        },
                        {
                            value: '0.5-1mm',
                            label: '0.5-1mm',
                        },
                        {
                            value: 'option.noPreference',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.noPreference',
                        },
                    ],
                    // disable: !(Array.isArray(formValues?.teethReductionPreference)
                    //     && (formValues?.teethReductionPreference).includes('option.palatalLingual')),
                    // validation: yup.string().required('Required'),
                    validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
                    // .when(['buccalFacial_teethReduction'], (v, _) => {
                    //     if (!v[0]) {
                    //         return yup.string().required('Required')
                    //     }
                    // }),
                },
            },
            showInUpsell: true,
        },

        10: {
            component: 'MergedPreRestorativeAlignerRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.preRestorativeAlignerSimulation',
            name: 'preRestorativeAlignerSimulation',
            remark: '@PatientInfo.smileDesign.prescriptionNotes.preRestorativeAlignerSimulationRemark',
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
            children: [
                {
                    component: 'MyTeethChoice',
                    question: '@PatientInfo.smileDesign.prescriptionNotes.question.selectTeethNotChangeFirstFit',
                    name: 'teethNotChange', // Picture
                    checkSuccess: false,
                    optional: true,
                    notShowOrder: true,
                    quickTeethOption: [
                        {
                            value: 'select',
                            label: 'Select',
                            teeth: [],
                        },
                        {
                            value: 'upper-arch',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.upperArch',
                            teeth: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                        },
                        {
                            value: 'lower-arch',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.lowerArch',
                            teeth: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
                        },
                        {
                            value: 'custom',
                            label: 'Custom',
                            teeth: [],
                        },
                    ],
                    showWhen: { field: 'preRestorativeAlignerSimulation', value: 'option.yes' },
                    showInUpsell: true,
                },
            ],
            showInUpsell: false,
        },
        '10_hidden': {
            name: 'upgradePreRestorativeAlignerSimulation',
            validation: yup.string().when(['preRestorativeAlignerSimulation'], (v, _) => {
                if (v[0] === 'option.yes') {
                    return yup.string().required('@NewPatient.prescriptionNotes.requiredInformation');
                }
            }),
            showInUpsell: false,
        },
        11: {
            component: 'TextFieldRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.remark',
            name: 'remark',
            showSingleError: false,
            showInUpsell: true,
        }
    };
    if (isUpSellTab) {
        let upsellObject = {};
        Object.keys(object).forEach((key) => {
            if (object[key]?.showInUpsell === true) {
                upsellObject[key === '11' ? '10' : key] = object[key];
            }
        });
        return upsellObject;
    }
    return object;
};

// Builds the standard Smile Design question configuration.
export const smilDesignQuestionsConfig = (formValues = undefined, isMarieGroup = false, isUpSellTab = false, isTWGroup = false) => {
    let object = {
        1: {
            component: 'RadioRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.plannedRestorationSolution',
            name: 'plannedRestorationSolution',
            option: [
                {
                    value: isMarieGroup ? 'option.formaInjectionTechnique' : 'option.flowableInjectionTechnique',
                    label: isMarieGroup
                        ? `@PatientInfo.smileDesign.prescriptionNotes.option.formaInjectionTechnique`
                        : `@PatientInfo.smileDesign.prescriptionNotes.option.flowableInjectionTechnique`,
                    disable: isTWGroup,
                },
                {
                    value: 'option.ceramicVeneersCrowns',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.ceramicVeneersCrowns',
                },
            ],
            // validation: yup.string().required('Required'),
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),

            children: {
                '2A': {
                    component: 'SDTeethRhf',
                    question: '@PatientInfo.smileDesign.prescriptionNotes.question.chooseDentalMorphology',
                    name: 'teethSD',
                    showSingleError: false,
                    // validation: yup
                    //     .array()
                    //     .when(['plannedRestorationSolution'], (v, _) => { // <= Q2A
                    //         if (v[0] === 'option.ceramicVeneers') {
                    //             return yup.array()
                    //                 .required('Choose one at least')
                    //                 .typeError('Choose one at least')
                    //                 .min(1, 'Choose one at least')
                    //         }
                    //     }),

                    // disable: !(formValues?.plannedRestorationSolution === 'option.ceramicVeneers'),
                    reset: '',
                },
            },
            showInUpsell: true,
        },
        2: {
            component: 'MyTeethChoice',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.selectTeethSimulationFirstFit',
            name: 'teethForSimulation', // Picture
            alwaysShowRequired: true,
            validation: yup
                .array()
                .required('@NewPatient.prescriptionNotes.requiredInformation')
                .typeError('@NewPatient.prescriptionNotes.requiredInformation')
                .min(1, '@NewPatient.prescriptionNotes.requiredInformation'),
            checkSuccess: true,
            quickTeethOption: [
                {
                    value: 'select',
                    label: 'Select',
                    teeth: [],
                },
                {
                    isGroup: true,
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.upperArch',
                },
                {
                    value: 'upper-2-2',
                    label: '2-2',
                    teeth: [6, 7, 8, 9],
                },
                {
                    value: 'upper-3-3',
                    label: '3-3',
                    teeth: [5, 6, 7, 8, 9, 10],
                },
                {
                    value: 'upper-4-4',
                    label: '4-4',
                    teeth: [4, 5, 6, 7, 8, 9, 10, 11],
                },
                {
                    value: 'upper-5-5',
                    label: '5-5',
                    teeth: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                },
                {
                    value: 'upper-all',
                    label: 'All',
                    teeth: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                },
                {
                    isGroup: true,
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.lowerArch',
                },
                {
                    value: 'lower-2-2',
                    label: '2-2',
                    teeth: [22, 23, 24, 25],
                },
                {
                    value: 'lower-3-3',
                    label: '3-3',
                    teeth: [21, 22, 23, 24, 25, 26],
                },
                {
                    value: 'lower-4-4',
                    label: '4-4',
                    teeth: [20, 21, 22, 23, 24, 25, 26, 27],
                },
                {
                    value: 'lower-5-5',
                    label: '5-5',
                    teeth: [19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
                },
                {
                    value: 'lower-all',
                    label: 'All',
                    teeth: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
                },
                {
                    isGroup: true,
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.dualArch',
                },
                {
                    value: 'both-2-2',
                    label: '2-2',
                    teeth: [6, 7, 8, 9, 22, 23, 24, 25],
                },
                {
                    value: 'both-3-3',
                    label: '3-3',
                    teeth: [5, 6, 7, 8, 9, 10, 21, 22, 23, 24, 25, 26],
                },
                {
                    value: 'both-4-4',
                    label: '4-4',
                    teeth: [4, 5, 6, 7, 8, 9, 10, 11, 20, 21, 22, 23, 24, 25, 26, 27],
                },
                {
                    value: 'both-5-5',
                    label: '5-5',
                    teeth: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
                },
                {
                    value: 'both-all',
                    label: 'All',
                    teeth: [
                        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
                        22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
                    ],
                },
                {
                    value: 'custom',
                    label: 'Custom',
                    teeth: [],
                },
            ],
            showInUpsell: true,
        },
        3: {
            component: 'RadioRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.increaseVerticalDimension',
            name: 'verticalDimension',
            option: [
                {
                    value: 'option.notIncreaseVerticalDimension',
                    label: `@PatientInfo.smileDesign.prescriptionNotes.option.notIncreaseVerticalDimension`,
                },
                {
                    value: 'option.increaseVerticalDimension',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.increaseVerticalDimension',
                },
            ],
            children: [
                {
                    component: 'QuestionTwoGroupOptionRhf',
                    question: '',
                    name: 'verticalDimensionPosterior',
                    showWhen: { field: 'verticalDimension', value: 'option.increaseVerticalDimension' },
                    children: {
                        a: {
                            component: 'SelectRhf',
                            question: '',
                            name: 'verticalDimensionUpperPosterior',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.upperPosterior',
                            defaultValue: '2mm',
                            option: [
                                ...(isUpSellTab ? [{ value: '', label: 'None' }] : []),
                                {
                                    value: '1mm',
                                    label: `1mm`,
                                },
                                {
                                    value: '2mm',
                                    label: '2mm',
                                },
                                {
                                    value: '3mm',
                                    label: '3mm',
                                },
                                {
                                    value: '4mm',
                                    label: '4mm',
                                },
                                {
                                    value: '5mm',
                                    label: '5mm',
                                },
                            ],
                        },
                        b: {
                            component: 'SelectRhf',
                            question: '',
                            name: 'verticalDimensionLowerPosterior',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.lowerPosterior',
                            defaultValue: '2mm',
                            option: [
                                ...(isUpSellTab ? [{ value: '', label: 'None' }] : []),
                                {
                                    value: '1mm',
                                    label: `1mm`,
                                },
                                {
                                    value: '2mm',
                                    label: '2mm',
                                },
                                {
                                    value: '3mm',
                                    label: '3mm',
                                },
                                {
                                    value: '4mm',
                                    label: '4mm',
                                },
                                {
                                    value: '5mm',
                                    label: '5mm',
                                },
                            ],
                        },
                    },
                },
            ],
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
            showInUpsell: true,
        },
        4: {
            component: 'RadioRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.midlineCorrectionInSimulation',
            name: 'midlineCorrectionInSimulation',
            direction: 'column',
            option: [
                {
                    value: 'option.facialMidlineUpperOnly',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.facialMidlineUpperOnly',
                },
                {
                    value: 'option.facialMidlineUpperLower',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.facialMidlineUpperLower',
                },
                {
                    value: 'option.noMidline',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.noMidlineV1',
                },
            ],
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
            showInUpsell: true,
        },
        5: {
            component: 'QuestionTwoGroupOptionRhf',
            question: ' ', // Explain: only show the order
            children: {
                a: {
                    component: 'RadioRhf',
                    name: 'buccalFacial_teethReduction',
                    question:
                        '@PatientInfo.smileDesign.prescriptionNotes.question.teethReductionPreference_buccalFacial',
                    // notShowOrder: true,
                    option: [
                        {
                            value: 'option.noReduction',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.noReduction',
                        },
                        {
                            value: '0-0.5mm',
                            label: '0-0.5mm',
                        },
                        {
                            value: '0.5-1mm',
                            label: '0.5-1mm',
                        },
                        {
                            value: 'option.noPreference',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.noPreference',
                        },
                    ],
                    // disable: !(Array.isArray(formValues?.teethReductionPreference)
                    //     && (formValues?.teethReductionPreference).includes('option.buccalFacial')),
                    validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
                    // .when(['palatalLingual_teethReduction'], (v, _) => {
                    //     if (!v[0]) {
                    //         return yup.string().required('Required')
                    //     }
                    // }),
                },
                b: {
                    component: 'RadioRhf',
                    name: 'palatalLingual_teethReduction',
                    question:
                        '@PatientInfo.smileDesign.prescriptionNotes.question.teethReductionPreference_palatalLingual',
                    // notShowOrder: true,
                    option: [
                        {
                            value: 'option.noReduction',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.noReduction',
                        },
                        {
                            value: '0-0.5mm',
                            label: '0-0.5mm',
                        },
                        {
                            value: '0.5-1mm',
                            label: '0.5-1mm',
                        },
                        {
                            value: 'option.noPreference',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.noPreference',
                        },
                    ],
                    // disable: !(Array.isArray(formValues?.teethReductionPreference)
                    //     && (formValues?.teethReductionPreference).includes('option.palatalLingual')),
                    // validation: yup.string().required('Required'),
                    validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
                    // .when(['buccalFacial_teethReduction'], (v, _) => {
                    //     if (!v[0]) {
                    //         return yup.string().required('Required')
                    //     }
                    // }),
                },
            },
            showInUpsell: true,
        },

        6: {
            component: 'MergedPreRestorativeAlignerRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.preRestorativeAlignerSimulation',
            name: 'preRestorativeAlignerSimulation',
            validation: yup.string().required('@NewPatient.prescriptionNotes.requiredInformation'),
            children: [
                {
                    component: 'MyTeethChoice',
                    question: '@PatientInfo.smileDesign.prescriptionNotes.question.selectTeethNotChangeFirstFit',
                    name: 'teethNotChange',
                    checkSuccess: false,
                    optional: true,
                    notShowOrder: true,
                    quickTeethOption: [
                        {
                            value: 'select',
                            label: 'Select',
                            teeth: [],
                        },
                        {
                            value: 'upper-arch',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.upperArch',
                            teeth: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                        },
                        {
                            value: 'lower-arch',
                            label: '@PatientInfo.smileDesign.prescriptionNotes.option.lowerArch',
                            teeth: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
                        },
                        {
                            value: 'custom',
                            label: 'Custom',
                            teeth: [],
                        },
                    ],
                    showWhen: { field: 'preRestorativeAlignerSimulation', value: 'option.yes' },
                    showInUpsell: true,
                },
            ],
            showInUpsell: false,
        },
        '6_hidden': {
            name: 'upgradePreRestorativeAlignerSimulation',
            validation: yup.string().when(['preRestorativeAlignerSimulation'], (v, _) => {
                if (v[0] === 'option.yes') {
                    return yup.string().required('@NewPatient.prescriptionNotes.requiredInformation');
                }
            }),
            showInUpsell: false,
        },
        
        7: {
            component: 'TextFieldRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.remark',
            name: 'remark',
            showSingleError: false,
            showInUpsell: true,
        },
    };
    if (isUpSellTab) {
        let upsellObject = {};
        Object.keys(object).forEach((key) => {
            if (object[key]?.showInUpsell === true) {
                upsellObject[key === '7' ? '6' : key] = object[key];
            }
        });
        return upsellObject;
    }
    return object;
};

export const smileDesignQuestionsAlignConfig = (formValues = undefined, isMarieGroup = false) => {
    const object = {
        1: {
            component: 'CheckboxRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.toolsToOrder',
            name: 'toolsToOrder',
            showSingleError: false,
            option: [
                {
                    value: 'option.gingivalReductionGuide',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.gingivalReductionGuide',
                },
                {
                    value: 'option.incisalPreparationGuide',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.incisalPreparationGuide',
                },
                {
                    value: 'option.preparationCheckGuide',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.preparationCheckGuide',
                },
                {
                    value: 'option.indexFinalSimulationTemporization',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.indexFinalSimulationTemporization',
                },
                {
                    value: isMarieGroup ? 'option.temporaryRestorationRetainerAligner' : 'option.temporaryRestoration',
                    label: isMarieGroup
                        ? '@PatientInfo.smileDesign.prescriptionNotes.option.temporaryRestorationRetainerAligner'
                        : '@PatientInfo.smileDesign.prescriptionNotes.option.temporaryRestoration',
                },
                {
                    value: isMarieGroup ? 'option.bleachingTray' : 'option.bleachingTrayPreOperation',
                    label: isMarieGroup
                        ? '@PatientInfo.smileDesign.prescriptionNotes.option.bleachingTray'
                        : '@PatientInfo.smileDesign.prescriptionNotes.option.bleachingTrayPreOperation',
                },
            ],
            validation: yup.array().required('Required').typeError('Required').min(1, 'Required'),
        },
    };

    return object;
};

// @ts-ignore
export const validationSchema = yup
    .object()
    .shape(buildValidationObject(smilDesignQuestionsConfig()), [
        'palatalLingual_teethReduction',
        'buccalFacial_teethReduction',
    ]);

// @ts-ignore
export const validationSchemaFirstFit = yup
    .object()
    .shape(buildValidationObject(smilDesignQuestionsConfigFirstFit()), [
        'palatalLingual_teethReduction',
        'buccalFacial_teethReduction',
    ]);

// @ts-ignore
export const validationSchemaAlign = yup.object().shape(buildValidationObject(smileDesignQuestionsAlignConfig()));

/**
 * Creates a Smile Design question schema for the selected display mode.
 */
export const createStaticSmileDesignQuestionSchema = ({
    isMarieGroup,
    isSEAGroup = false,
    isUpSellTab = false,
    displayFirstFitFlag = false,
}) => {
    const questionConfig = displayFirstFitFlag ? smilDesignQuestionsConfigFirstFit : smilDesignQuestionsConfig;
    return yup
        .object()
        .shape(buildValidationObject(questionConfig(undefined, isMarieGroup, isUpSellTab, false, isSEAGroup)), [
            'palatalLingual_teethReduction',
            'buccalFacial_teethReduction',
        ])
        .test('vertical-dimension-posterior', 'Select an increase for at least one jaw', function (values) {
            // Require at least one jaw to have a positive increase.
            if (
                values?.verticalDimension === 'option.increaseVerticalDimension' &&
                (!values?.verticalDimensionUpperPosterior || values.verticalDimensionUpperPosterior === '0') &&
                (!values?.verticalDimensionLowerPosterior || values.verticalDimensionLowerPosterior === '0')
            ) {
                return this.createError({ path: 'verticalDimensionPosterior' });
            }
            return true;
        });
};
